import {Component, computed, input} from '@angular/core';
import {ClientPathComponent} from '../client-path/client-path.component';

/**
 * One registration in a time line: "09:15–09:30" (mono) and the task with "klant › project" below.
 * `state` marks an approved or disapproved registration. Projected content (e.g. comments) goes below the task.
 */
@Component({
    selector: 'app-time-entry',
    imports: [ClientPathComponent],
    templateUrl: './time-entry.component.html',
    styles: `
        :host {
            display: grid;
            grid-template-columns: 86px minmax(0, 1fr);
            gap: 8px;
            padding: 5px 0;
            border-bottom: 1px solid #f6f7f8;
            color: #1f2328;
        }

        :host(.approved) {
            background: #f3faf6;
        }

        :host(.disapproved) {
            background: #fff7f6;
        }

        .time {
            padding-top: 1px;
            font-family: 'Roboto Mono', ui-monospace, monospace;
            font-size: 12px;
            color: #4b5563;
            white-space: nowrap;
        }

        .main {
            display: flex;
            flex-direction: column;
            gap: 1px;
            min-width: 0;
        }

        .task-line {
            display: flex;
            align-items: center;
            gap: 6px;
            min-width: 0;
        }

        .task {
            min-width: 0;
            font-size: 13px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        i {
            flex: none;
            font-size: 12px;
        }
    `,
    host: {
        '[class.approved]': 'state() === "approved"',
        '[class.disapproved]': 'state() === "disapproved"',
        '[attr.title]': 'tooltip() || fullText()'
    }
})
export class TimeEntryComponent {
    /** "09:15" */
    readonly start = input<string>('');
    readonly end = input<string>('');
    readonly task = input<string>('');
    readonly client = input<string>('');
    readonly path = input<string | (string | null | undefined)[]>([]);
    readonly companyId = input<number | string | null>(null);
    readonly state = input<'approved' | 'disapproved' | null>(null);
    /** Tooltip of the whole entry; defaults to "Klant » project » taak". */
    readonly tooltip = input<string | null>(null);

    readonly fullText = computed(() => {
        const path = this.path();
        return [this.client(), ...(Array.isArray(path) ? path : [path]), this.task()].filter(part => !!part).join(' » ');
    });
}
